import { render, staticRenderFns } from "./bookmark-add-menu.vue?vue&type=template&id=633f2222&scoped=true&"
import script from "./bookmark-add-menu.vue?vue&type=script&lang=ts&"
export * from "./bookmark-add-menu.vue?vue&type=script&lang=ts&"
import style0 from "./bookmark-add-menu.vue?vue&type=style&index=0&id=633f2222&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "633f2222",
  null
  
)

export default component.exports